"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TextWrapper = exports.TextBoxWithDesktopGap = exports.Root = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
var _shared = require("../shared");
const Root = exports.Root = (0, _mui.styled)('div', {
    shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})((param)=>{
    let { theme, position } = param;
    return {
        alignItems: 'center',
        maxWidth: '100%',
        display: 'flex',
        gap: theme.spacing(3),
        width: '100%',
        justifyContent: 'center',
        flexDirection: 'column',
        [theme.breakpoints.up('sm')]: {
            flexDirection: position === 'left' ? 'row-reverse' : 'row',
            gap: theme.spacing(6)
        }
    };
});
const TextWrapper = exports.TextWrapper = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        alignContent: 'center',
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            width: 350
        }
    };
});
const TextBoxWithDesktopGap = exports.TextBoxWithDesktopGap = (0, _mui.styled)(_shared.TextBox)((param)=>{
    let { theme } = param;
    return {
        margin: theme.spacing(0, 3),
        h4: {
            margin: 0
        },
        [theme.breakpoints.up('sm')]: {
            gap: theme.spacing(6, 0),
            margin: 0
        }
    };
});
